<template>
	<div class="tutor">
		<h2>IUI components</h2>
		<table border="1">
			<thead>
				<tr>
					<td>в коде</td>
					<td>Описание</td>
					<td style="width:420px;">Вид</td>
					<td>Атрибуты</td>
					<td>Методы</td>
				</tr>
			</thead>
			<tbody>
				<tr v-for="comp in comps">
					<td><code>&lt;{{comp.name}}/&gt;</code></td>
					<td>{{comp.description}} 
						<details>
							<summary>example</summary>
							<code><pre>{{comp.example}}</pre></code>
						</details>
					</td>
					<td><component :is="comp.name"/></td>
					<td>
						<span class="prop" v-for="prop in comp.propsSimple">{{prop}}</span>
						<details>
							<summary>more</summary>
							<code><pre>{{comp.props}}</pre></code>
						</details>
					</td>
					<td>
						<span class="prop" v-for="prop in comp.methodsSimple">{{prop}}</span>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import Icon from "../icon.vue";
import TextBox from "../textbox.vue";
import Btn from "../button.vue";
import Inputi from "../inputi.vue";
import ListSelect from "../list-select.vue";
import iCheckbox from "../icheckbox.vue";
import iLabel from "../ilabel.vue";
import iToggle from "../itoggle.vue";
import iForm from "../i-components/i-form.vue";
import iList from "../i-components/i-list.vue";
import Modal from "../desktop/modal.vue";
import Tabs from "../desktop/tabs.vue";
import Tab from "../desktop/tab.vue";
import iPaginator from "../i-components/i-paginator.vue";
//import iToggle from "../desktop/";
//console.log(Icon)
let components = {Icon,TextBox,Btn,Inputi,ListSelect,iCheckbox,iLabel,iToggle,iForm,Modal,iList, Tab,iPaginator};
export default {
	components,
  name: 'tutor',

  data () {
    return {

    }
  },
  computed:{
  	comps(){
  		return Object.keys(components).map((compName)=>{
  			let comp = components[compName];
  			console.log(comp)
  			console.log(comp.methods)
  			let compParsed = {};
  			compParsed.name = comp.name;
  			compParsed.description = comp.description;
  			compParsed.example = comp.example;
  			//compParsed.props = comp.props;
  			if(comp.methods){
	  			compParsed.methodsSimple = Object.keys(comp.methods);
	  			compParsed.methods = comp.methods;
  			}
  			//console.log(comp)
  			if(comp.props){
  				compParsed.propsSimple = Object.keys(comp.props);
  				compParsed.props = Object.keys(comp.props).reduce((ns,pName)=>{
  					let p = comp.props[pName];
  					let newP = {};
  					if(typeof p.default === 'function'){
  						newP.default = p.default();
  					} else {
  						newP.default = p.default;
  					}
  					if(p.required){
  						newP.required = p.required;
  					}

  					ns[pName] = newP;
  					return ns;
  				},{});
  			}
  			//console.log(comp);
  			return compParsed;
  		});
  	}
  }
}
</script>

<style lang="css" scoped>
.tutor{
	padding:4px;
}
table{
	border-collapse: collapse;
}

table td{
	padding:4px;
}
.prop{
	border-radius: 4px;
	padding:2px 6px;
	margin:2px;
	display: inline-block;
}
summary{
	cursor: pointer;
}
.prop:nth-child(1){background:hsl(0,100%,85%);}
.prop:nth-child(2){background:hsl(40,100%,85%);}
.prop:nth-child(3){background:hsl(80,100%,85%);}
.prop:nth-child(4){background:hsl(120,100%,85%);}
.prop:nth-child(5){background:hsl(160,100%,85%);}
.prop:nth-child(6){background:hsl(200,100%,85%);}
.prop:nth-child(7){background:hsl(240,100%,85%);}
.prop:nth-child(8){background:hsl(280,100%,85%);}
.prop:nth-child(9){background:hsl(320,100%,85%);}
.prop:nth-child(10){background:hsl(360,100%,85%);}
.prop:nth-child(11){background:hsl(400,100%,85%);}
.prop:nth-child(12){background:hsl(440,100%,85%);}
.prop:nth-child(13){background:hsl(480,100%,85%);}
.prop:nth-child(14){background:hsl(520,100%,85%);}
.prop:nth-child(15){background:hsl(560,100%,85%);}
.prop:nth-child(16){background:hsl(600,100%,85%);}
.prop:nth-child(17){background:hsl(640,100%,85%);}
.prop:nth-child(18){background:hsl(680,100%,85%);}
.prop:nth-child(19){background:hsl(720,100%,85%);}
.prop:nth-child(20){background:hsl(760,100%,85%);}
.prop:nth-child(21){background:hsl(800,100%,85%);}
.prop:nth-child(22){background:hsl(840,100%,85%);}
.prop:nth-child(23){background:hsl(880,100%,85%);}
.prop:nth-child(24){background:hsl(920,100%,85%);}
</style>